<div class="ebo-section-header">
  <span *ngIf="title" class="ebo-section-header__title">{{ title }}</span>
  <span *ngIf="subtitle" class="ebo-section-header__subtitle">{{ subtitle }}</span>
</div>
